import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ProductPipe } from '@signature-it/ngx-catalogue/pipes';
import {GenericConfig} from "@signature-it/ngx-generic/config";

@Component({
    selector: 'orders-layout-checkout',
    templateUrl: './checkout.html',
    styleUrls: ['./checkout.scss'],
    standalone: false
})
export class OrdersCheckoutLayoutComponentGeneric {
    @Input('items') items = {
        TransactionItems: Array<object>(),
        OrderItems: Array<object>()
    };
    @Input() isMiniCart = false;
    @Output() editCart = new EventEmitter();
    public scrollbarOptions = { axis: 'y', theme: 'dark-thick'};
    hideProductImageBox: boolean = GenericConfig.hideProductImageBox || false;


    actionsConf = {
        showEdit: true,
        showClearAll: false
    };

    onEditCart() {
        this.editCart.next(true);
    }

}
